import React, { FunctionComponent } from 'react';
import gql from 'graphql-tag';
import { Totaliser } from '@justgiving/totaliser';
import { AuctionTotaliserWrapperFragment } from '../../../../types/__generated__';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../../hooks/usePageQuery';
import '@justgiving/totaliser/src/Totaliser.scss';
import '@justgiving/totaliser/src/themes/PixelHeart/PixelHeart.scss';
import TotaliserWrapperSkeleton from '../../TotaliserWrapperSkeleton/TotaliserWrapperSkeleton';

const FRAGMENT = buildQuery(gql`
  fragment AuctionTotaliserWrapper on Page {
    targetWithCurrency {
      value
    }
    donationSummary {
      totalAmount {
        value
      }
    }
  }
`);

interface AuctionTotaliserWrapperProps {
  additionalIncome?: number;
}

const AuctionTotaliserWrapper: FunctionComponent<AuctionTotaliserWrapperProps> = ({
  additionalIncome,
}) => {
  const result = usePageQuery<AuctionTotaliserWrapperFragment>(FRAGMENT, {
    notifyOnNetworkStatusChange: true,
  });

  if (result.loading) {
    return <TotaliserWrapperSkeleton animated displayRefreshButton={false} />;
  }

  if (result.error) {
    return <TotaliserWrapperSkeleton onRefresh={result.refetch} />;
  }

  if (!UsePageQueryResult.hasData(result)) {
    return null;
  }

  const target = result.data.targetWithCurrency?.value;
  const totalAmount =
    result.data.donationSummary?.totalAmount?.value +
    (additionalIncome ? additionalIncome * 100 : 0);
  const percentageOfTarget =
    target && (totalAmount || totalAmount === 0)
      ? (totalAmount / target) * 100
      : undefined;

  // console.log(
  //   'TotaliserWrapper: ',
  //   target,
  //   additionalIncome,
  //   totalAmount,
  //   percentageOfTarget,
  // );

  if (percentageOfTarget === undefined) {
    return null;
  }

  return (
    <Totaliser
      key={`auction-totaliser-${percentageOfTarget}`}
      className="jg-pages-totaliser-main"
      percent={percentageOfTarget}
      size="auto"
      isAnimated={false}
    />
  );
};

export default AuctionTotaliserWrapper;
